import { render } from "./Temperatura.vue?vue&type=template&id=fc44f96a"
import script from "./Temperatura.vue?vue&type=script&lang=js"
export * from "./Temperatura.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__